import { Form, Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { Constants } from "../../Common/Constants";
import { types } from "../../../Redux/Actions/types";
import TextField from "../../Common/Fields/TextField";
import ButtonCustom from "../../Common/Fields/ButtonCustom";
import { forceInsert, forceList, forceUpdate } from "../../../Redux/Actions";
import usePermissions from "../../Common/Functions/usePermissions";

const ForceForm = () => {
  const dispatch = useDispatch();
  const { forceSingle } = useSelector((state) => state.Force);
  // Permissions
  const addPermission = usePermissions(Constants.permission.MECHANICS_ADD);
  const editPermission = usePermissions(Constants.permission.MECHANICS_EDIT);

  // Initial values to force form
  const [initialValues, setInitialValues] = useState({
    name: "",
  });

  // Validations for force form
  const validationSchema = Yup.object().shape({
    name: Yup.string().required(Constants.required),
  });

  useEffect(() => {
    // Set initial values to pre fill force form
    if (forceSingle?._id) {
      const editValue = {};
      for (const [key] of Object.entries(initialValues)) {
        if (forceSingle[key]) {
          editValue[key] = forceSingle[key];
        }
        setInitialValues(editValue);
      }
    }
  }, [forceSingle]);

  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize={true}
      validationSchema={validationSchema}
      onSubmit={(values) => {
        // Add or update force API
        let submitFunc = forceInsert(values);
        if (forceSingle._id) {
          values.id = forceSingle._id;
          submitFunc = forceUpdate(values);
        }
        dispatch(submitFunc).then((response) => {
          if (response.error) {
            dispatch({
              type: types.ERROR_ALERT_VISIBLE,
              payload: response.error,
            });
          } else {
            dispatch({
              type: types.SUCCESS_ALERT_VISIBLE,
              payload: response.message,
            });
            dispatch({ type: types.FORCE_SINGLE, payload: "" });
            dispatch({ type: types.FORCE_FORM_MODEL, payload: "" });
          }
          dispatch(forceList());
        });
      }}
    >
      {({ errors, touched }) => (
        <Form className="row">
          <div className="col-md-12 mb-2">
            <TextField
              type="text"
              name="name"
              className="form-control"
              errors={touched?.name ? errors?.name : undefined}
              touched={touched?.name}
              label={Constants.name}
            />
          </div>
          {((addPermission && !forceSingle?._id) ||
            (editPermission && forceSingle?._id)) && (
            <ButtonCustom label={Constants.submit} type="submit" />
          )}
        </Form>
      )}
    </Formik>
  );
};

export default ForceForm;
